module.exports = __webpack_public_path__ + "media/images/default/pages/about/clinic-1-829cfd74516eeb29d4fad410577acd70.jpeg";